@if (hasAddress) {
<div class="myaccount-delivery-wrapper">
  <h2>{{ 'personalInfo.deliveryAddress' | cxTranslate }}</h2>
  @if (hasShippingPending) {
  <div class="myaccount-personal-shipping-pending alert alert-info alert-dismissible fade show" role="alert">
    <mat-icon class="material-icons-outlined">error_outline</mat-icon>
    {{ 'personalInfo.hasPendingShipping' | cxTranslate }}
  </div>
  }
  <div class="myaccount-delivery-container">
    @for (add of address.shippingAddress; track add; let addressCount = $count) {
    <div
      class="myaccount-delivery-address"
      [ngClass]="activeCountry$ | async"
      [ngClass]="
        add.defaultAddress && addressCount > 1 && (isChangeDefaultDeliveryAddressEnabled$ | async)
          ? 'myaccount-default-address'
          : 'myaccount-nondefault-address'
      "
      [class.disabled]="add?.approvalStatus === 'PENDING'"
      [class.change-disabled]="!(isChangeDefaultDeliveryAddressEnabled$ | async)"
      [class.cn]="!(isCountyEnabled$ | async)"
      [class.hide-checkbox-space]="(isChangeDefaultDeliveryAddressEnabled$ | async) && addressCount == 1"
    >
      <div
        class="column-2"
        [class.one-address]="!(addressCount > 1) && !(showAddressName$ | async)"
        [class.one-address-shown]="!(addressCount > 1) && (showAddressName$ | async)"
      >
        @if ((isChangeDefaultDeliveryAddressEnabled$ | async) && addressCount > 1) {
        <div class="checkbox">
          <mat-radio-button
            class=""
            value="add.addressId"
            (click)="add?.approvalStatus === 'APPROVED' && setDefaultAdd(add.addressId)"
            [checked]="add.defaultAddress ? 'checked' : null"
            [disabled]="add?.approvalStatus === 'PENDING'"
          ></mat-radio-button>
        </div>
        }
        <div
          class="description"
          [ngClass]="activeCountry$ | async"
          [class.cn]="!(isChangeDefaultDeliveryAddressEnabled$ | async) && (activeCountry$ | async) === 'cn'"
        >
          <div class="myaccount-address-th">
            @if ( this.isDesktop && add.addressName && !(showAddressName$ | async)) {
            <span class="myaccount-address-name">{{ add.addressName }}</span>
            } @else { @if (this.isDesktop) {
            <span class="myaccount-address-name">{{ 'myAccount.address' | cxTranslate }}</span>
            } } @if (!this.isDesktop) {
            <span class="myaccount-address-name is-mobile">{{ 'myAccount.address' | cxTranslate }}</span>
            } @if (add.defaultAddress) {
            <span class="activate-default-address">{{ 'personalInfo.defaultDelivery' | cxTranslate }}</span>
            }
          </div>
          <div class="myaccount-address-td" [innerHTML]="showAddress(add)"></div>
        </div>
      </div>
      <div class="column-3">
        <div class="myaccount-address-th">{{ 'personalInfo.postalCode' | cxTranslate }}</div>
        <div class="myaccount-address-td">{{ add.postalCode }}</div>
      </div>
      <div class="column-4">
        <div class="myaccount-address-th">{{ 'personalInfo.city' | cxTranslate }}</div>
        <div class="myaccount-address-td">{{ add.town }}</div>
      </div>
      <div class="column-5">
        <div class="myaccount-address-th">{{ 'personalInfo.state' | cxTranslate }}</div>
        <div class="myaccount-address-td">{{ (isCountyEnabled$ | async) ? add.region?.name : add.district }}</div>
      </div>
      @if (isCountyEnabled$ | async) {
      <div class="column-6">
        <div class="myaccount-address-th">{{ 'personalInfo.county' | cxTranslate }}</div>
        <div class="myaccount-address-td">{{ add.district }}</div>
      </div>
      }
      <div class="column-7" [class.cn]="!(isCountyEnabled$ | async)">
        <div class="myaccount-address-th">{{ 'personalInfo.country' | cxTranslate }}</div>
        <div class="myaccount-address-td">{{ add.country?.name }}</div>
      </div>
      @if ((isDeleteDeliveryAddressEnabled$ | async) && isChangeDefaultDeliveryAddressEnabled$ | async) {
      <div class="column-8">
        <button
          type="button"
          class="close"
          aria-label="Delete"
          (click)="deleteAddressModal(add.id)"
          [disabled]="add?.approvalStatus === 'PENDING'"
        >
          <mat-icon
            matTooltip="{{ 'buttonTooltip.myAccount.deleteEntry' | cxTranslate }}"
            [matTooltipPosition]="'below'"
            matTooltipClass="icon-tooltip"
            aria-label="displays a tooltip in bottom"
            class="mat-icon-rtl-mirror"
            [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
            >close</mat-icon
          >
        </button>
      </div>
      }
    </div>
    } @if ((isRequestNewDeliveryAddressEnabled$ | async) && isChangeDefaultDeliveryAddressEnabled$ | async) {
    <div class="myaccount-new-address">
      <button
        class="tertiary-btn delete-cart"
        type="button"
        aria-haspopup="true"
        aria-expanded="false"
        (click)="onRequestNewDeliveryAddr()"
      >
        <mat-icon>add</mat-icon> {{ 'personalInfo.requestNewDelivery' | cxTranslate }}
      </button>
    </div>
    }
  </div>
</div>
<div class="myaccount-billing-wrapper">
  <h2>{{ 'personalInfo.billingAddress' | cxTranslate }}</h2>
  @if (hasBillingPending) {
  <div class="myaccount-personal-billing-pending alert alert-info alert-dismissible fade show" role="alert">
    <mat-icon class="material-icons-outlined">error_outline</mat-icon>
    <span>{{ 'personalInfo.hasPendingBilling' | cxTranslate }}</span>
  </div>
  }
  <div class="myaccount-billing-container" [class.disabled]="hasBillingPending">
    @for (add of address.billingAddress; track add) { @if (add.approvalStatus === 'APPROVED' && add.billingAddress &&
    add.visibleInAddressBook) {
    <div
      class="myaccount-billing-address"
      [class.billing-pending]="hasBillingPending"
      [class.cn]="!(isCountyEnabled$ | async)"
    >
      <div class="column-2">
        <div class="myaccount-address-th">
          {{ 'myAccount.address' | cxTranslate }}
        </div>
        <div class="myaccount-address-td" [innerHTML]="showAddress(add)"></div>
      </div>
      <div class="column-3">
        <div class="myaccount-address-th">{{ 'personalInfo.postalCode' | cxTranslate }}</div>
        <div class="myaccount-address-td">{{ add?.postalCode }}</div>
      </div>
      <div class="column-4">
        <div class="myaccount-address-th">{{ 'personalInfo.city' | cxTranslate }}</div>
        <div class="myaccount-address-td">{{ add?.town }}</div>
      </div>
      <div class="column-5">
        <div class="myaccount-address-th">{{ 'personalInfo.state' | cxTranslate }}</div>
        <div class="myaccount-address-td">
          {{ (isCountyEnabled$ | async) ? add?.region?.name : add?.district }}
        </div>
      </div>
      @if (isCountyEnabled$ | async) {
      <div class="column-6">
        <div class="myaccount-address-th">{{ 'personalInfo.county' | cxTranslate }}</div>
        <div class="myaccount-address-td">{{ add?.district }}</div>
      </div>
      }
      <div class="column-7" [class.cn]="!(isCountyEnabled$ | async)">
        <div class="myaccount-address-th">{{ 'personalInfo.country' | cxTranslate }}</div>
        <div class="myaccount-address-td">{{ add?.country?.name }}</div>
      </div>
      <div class="column-8">
        @if ((isEditBillingAddressEnabled$ | async) && isChangeDefaultDeliveryAddressEnabled$ | async) {
        <button
          mat-button
          disableRipple
          class="btn btn-billing-address"
          [disabled]="hasBillingPending"
          (click)="
            updateBIllingAddressModal(
              add?.country?.isocode,
              add?.line1,
              add?.line2,
              add?.postalCode,
              add?.town,
              add?.region?.isocode,
              add?.region?.name,
              add?.district,
              add?.firstName,
              add?.lastName
            )
          "
        >
          <mat-icon
            matTooltip="{{ 'buttonTooltip.myAccount.editEntry' | cxTranslate }}"
            [matTooltipPosition]="'below'"
            matTooltipClass="icon-tooltip"
            aria-label="displays a tooltip in bottom"
            class="material-icons-sharp light billing-address"
            [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
            >create</mat-icon
          >
        </button>
        }
      </div>
    </div>
    } @else { @if (add.approvalStatus === 'APPROVED' && add.billingAddress && !hasBillingPending) {
    <div class="myaccount-billing-address">
      <div class="column-2">
        <div class="myaccount-address-th">{{ 'myAccount.address' | cxTranslate }}</div>
        <div class="myaccount-address-td">{{ add?.line1 }} {{ add?.line2 }}</div>
      </div>
      <div class="column-3">
        <div class="myaccount-address-th">{{ 'personalInfo.postalCode' | cxTranslate }}</div>
        <div class="myaccount-address-td">{{ add?.postalCode }}</div>
      </div>
      <div class="column-4">
        <div class="myaccount-address-th">{{ 'personalInfo.city' | cxTranslate }}</div>
        <div class="myaccount-address-td">{{ add?.town }}</div>
      </div>
      <div class="column-5">
        <div class="myaccount-address-th">{{ 'personalInfo.state' | cxTranslate }}</div>
        <div class="myaccount-address-td">
          {{ (isCountyEnabled$ | async) ? add?.region?.name : add?.district }}
        </div>
      </div>
      @if (isCountyEnabled$ | async) {
      <div class="column-6">
        <div class="myaccount-address-th">{{ 'personalInfo.county' | cxTranslate }}</div>
        <div class="myaccount-address-td">{{ add?.district }}</div>
      </div>
      }
      <div class="column-7" [class.cn]="!(isCountyEnabled$ | async)">
        <div class="myaccount-address-th">{{ 'personalInfo.country' | cxTranslate }}</div>
        <div class="myaccount-address-td">{{ add?.country?.name }}</div>
      </div>
      <div class="column-8">
        @if ((isEditBillingAddressEnabled$ | async) && isChangeDefaultDeliveryAddressEnabled$ | async) {
        <button
          mat-button
          class="btn btn-billing-address"
          [disabled]="hasBillingPending"
          (click)="
            updateBIllingAddressModal(
              add?.country?.isocode,
              add?.line1,
              add?.line2,
              add?.postalCode,
              add?.town,
              add?.region?.isocode,
              add?.region?.name,
              add?.district,
              add?.firstName,
              add?.lastName
            )
          "
        >
          <mat-icon
            matTooltip="{{ 'buttonTooltip.myAccount.editEntry' | cxTranslate }}"
            [matTooltipPosition]="'below'"
            matTooltipClass="icon-tooltip"
            aria-label="displays a tooltip in bottom"
            class="material-icons-sharp light billing-address"
            [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
            >create</mat-icon
          >
        </button>
        }
      </div>
    </div>
    } } }
  </div>
</div>
}
